/**
 * To define all supported file formats in FileUpload
 */
 const SupportedFileUploadFormats: Array<string> = new Array(
  'wav',
  'mp3',
  'mp4',
  'm4a',
);

/**
 * To define all supported file content types in FileUpload
 */
const SupportedFileUploadContentTypes: Array<string> = new Array(
  'audio/wav',
  'audio/wave',
  'audio/mpeg',
  'audio/mp4',
  'audio/m4a',
  'audio/x-ms-wma',
  'audio/x-m4a',
  'video/mp4',
  'video/x-ms-wma',
  'audio/webm',
  'video/webm',
);

export function IsFileFormatSupportedForUpload(fileFormat: string | undefined): boolean {
  if (fileFormat != null && fileFormat != undefined && fileFormat != '' && SupportedFileUploadFormats.indexOf(fileFormat) != -1) {
    return true;
  }

  return false;
}

export function IsFileContentTypeSupportedForUpload(fileContentType: string | undefined): boolean {
  if (fileContentType != null && fileContentType != undefined && fileContentType != '' && SupportedFileUploadContentTypes.indexOf(fileContentType) != -1) {
    return true;
  }

  return false;
}